import coverImg from "assets/images/v152/bg.webp"
import pictureImg from "assets/images/v152/cover.webp"
import titleImg from "assets/images/v152/title.webp"
import topImg from "assets/images/v152/top.webp"

export const v152Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
  picture: pictureImg,
  top: { en: topImg },
}
